import { configure } from 'mobx';
import { unstable_batchedUpdates } from 'react-dom';

// Wallet extensions inject their own MobX into the page. Its global state
// version does not match ours, so MobX throws error 35 on a timer even though
// this app only ships one copy. Isolation keeps our stores and observers
// together and skips that throw. The React scheduler is set again because
// isolation replaces the global state mobx-react-lite already configured.
if (!globalThis.__bidaliMobxIsolated) {
  configure({
    isolateGlobalState: true,
    reactionScheduler: unstable_batchedUpdates,
  });
  globalThis.__bidaliMobxIsolated = true;
}
